import React, { HTMLAttributes, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReceiptInquireForm from "./inquireForm";
import ReceiptRecords from "./receiptRecords";
import SelectReceiptParkingPage from "./selectReceiptParkingPage";

interface IReceiptListPage {}

type TReceiptListPageProps = IReceiptListPage & HTMLAttributes<HTMLDivElement>;

const ReceiptListPage: React.FC<TReceiptListPageProps> = (props) => {
  const { ...otherProps } = props;
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  // const blockAccess = queryParams.get("ivanis");

  const goNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const goBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const goStep = (step: number) => {
    setCurrentStep(step);
  };

  const goHomeAndRemoveQueryParam = () => {
    // Get current query parameters
    const queryParams = new URLSearchParams(location.search);

    // Remove the "id" parameter
    queryParams.delete("id");

    // Update the URL using React Router's navigate function
    navigate(`${location.pathname}`, {
      replace: true,
    });

    // Update the step
    setCurrentStep(1);
  };

  // console.log("currentStep", currentStep);

  return (
    <div className="px-3" {...otherProps}>
      {/* select carpark page */}
      {currentStep === 1 && (
        <SelectReceiptParkingPage goNext={goNext} goStep={goStep} />
      )}

      {currentStep === 2 && (
        <ReceiptInquireForm
          goNext={goNext}
          goHomeAndRemoveQueryParam={goHomeAndRemoveQueryParam}
        />
      )}

      {currentStep === 3 && (
        <ReceiptRecords
          goNext={goNext}
          goHomeAndRemoveQueryParam={goHomeAndRemoveQueryParam}
        />
      )}
    </div>
  );
};

export default ReceiptListPage;
